import React from "react";
import styles from "./LoadingSpinner.module.css";

const LoadingSpinner = () => {
  return (
    <div className={styles.spinnerContainer}>
      <div className={styles.furnitureSpinner}>
        <div className={styles.spinnerRing}></div>
        <div className={styles.spinnerRing}></div>
        <div className={styles.spinnerRing}></div>
        <div className={styles.spinnerCore}></div>
      </div>
      <p className={styles.loadingText}>Crafting your experience...</p>
    </div>
  );
};

export default LoadingSpinner;
